import axios from 'axios'

export const posts = axios.create({
    baseURL: 'https://paolo-stoppa-blog.firebaseio.com/'
})

export const ipify = axios.create({
    baseURL: 'https://api.ipify.org/?format=json'
})
